$(document).ready(function(){
    $(document).on('click','.variant-input',function(){
      $(".ShippingTextjtpl").html("");
      setTimeout(function() {
      var crrntLocation = new URLSearchParams(window.location.search);
     var param = crrntLocation.get('variant');
    var product_id = $("body").attr('data-product-id');
    var varientArray = [product_id , param];
      inventoryAjax(varientArray);
      },20);

  });

  
  
function inventoryAjax(varientArray){

  // var EU_Left = $('.customJTPL-DelivaryShow').attr('eu-avl');
  // var China_LEFT = $('.customJTPL-DelivaryShow').attr('china-avl');
  var Stratford_Store = `Available in store (Ships 1-3 days)`;
  var Warehouse_2 = `Warehouse (Ships 2-4 days)`;
  var Warehouse_3 = `Warehouse (Ships 7-10 days)`;
  var Warehouse_4 = ``;

    $.ajax({
      url: "/a/inventory/index.php",
      type: "POST",
      dataType: "HTML",
      data: {varientArray},
      crossDomain: true,
      success: function(Data){
        var new_Data = Data.trim()
        if(new_Data == 'Stratford'){
          $(".ShippingTextjtpl").html(Stratford_Store);
        } else if(new_Data == 'Warehouse (2-4 days)'){
         $(".ShippingTextjtpl").html(Warehouse_2);
        }else if(new_Data == 'Warehouse (5-7 days)'){
          $(".ShippingTextjtpl").html(Warehouse_3);
          
        }else if(new_Data == 'Tradeshow'){
            $(".ShippingTextjtpl").html(Warehouse_4);
       }else if(new_Data =='out of stock'){
           // $(".ShippingTextjtpl").html("This product is out of stock");
        }
        else{
         $(".ShippingTextjtpl").html("");
        }
      },
      error: function(){
        console.log("error" + varientArray)
      }
      
    })
}
  
  if($("body").attr("data-product-id") !== undefined){
  var product_id = $("body").attr("data-product-id");
  var variant_id = $("body").attr("data-variant-id");
      var varientArray = [product_id , variant_id];
    inventoryAjax(varientArray);
 }

});